// YouTube id from what the team pastes: a watch / share / shorts / embed link, or the bare id.
export function youtubeId(input: string | null | undefined): string | null {
  const s = (input || '').trim();
  if (!s) return null;
  if (/^[\w-]{11}$/.test(s)) return s;
  try {
    const u = new URL(s);
    if (!/(^|\.)youtube(-nocookie)?\.com$|(^|\.)youtu\.be$/.test(u.hostname)) return null;
    const id = u.hostname.endsWith('youtu.be') ? u.pathname.slice(1) : u.searchParams.get('v') || u.pathname.match(/\/(?:shorts|embed|live)\/([\w-]{11})/)?.[1] || '';
    return /^[\w-]{11}$/.test(id) ? id : null;
  } catch {
    return null;
  }
}

/** Mila's "how it works" video (Ahmed, 17 Oct); NEXT_PUBLIC_HOWTO_VIDEO_URL overrides it. */
export const DEFAULT_HOWTO_VIDEO = 'iukOvbo5znU';
